import { useEffect } from 'react';

import { useFocus } from '@app/hooks/useFocus';
import { Row } from '@app/utils/epgUtils';
import { getFieldOnMainLanguage } from '@app/utils/languages';
import { Autocomplete, Button, Dialog, TextField } from '@mui/material';

interface AutoCompleteEditorProps {
  row: any;
  column: any;
  onRowChange(row: Row, value?: boolean): void;
  onClose(): void;
}

export const AutoCompleteEditor = ({ row, column, onRowChange, onClose }: AutoCompleteEditorProps) => {
  const { htmlElRef, setFocus } = useFocus();

  useEffect(() => {
    setFocus();
  }, [htmlElRef, setFocus]);

  const onKeyDown = (e: any) => {
    const keyCode = e.code;

    if (keyCode === 'Enter' || keyCode === 'Backspace') {
      e.stopPropagation();
    }
  };

  return (
    <Dialog onClose={onClose} open>
      <div style={{ padding: 15, width: 600 }}>
        <Autocomplete
          multiple
          onKeyDown={onKeyDown}
          value={row[column.key]}
          getOptionLabel={(option) =>
            column.label ? getFieldOnMainLanguage(option[column.label]) : column?.getLabel(option)
          }
          onChange={(event: any, newValue) => {
            onRowChange({ ...row, [column.key]: newValue });
          }}
          options={column.source}
          fullWidth
          // eslint-disable-next-line jsx-a11y/no-autofocus
          renderInput={(params) => <TextField {...params} autoFocus ref={htmlElRef} label={column.name} />}
        />
        <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '20px' }}>
          <Button size="small" variant="contained" onClick={onClose}>
            Done
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
